import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class SpisakDokumenata extends BaseEntity{

    constructor(){
        super();
    }
    ID: number;
    // Povezan: boolean; 
    MasterDokumID: number; 
    Broj: string;
    Datum: NgbDate;    
    Ukupno: number;
    VezaDokID: number;
    ObjekatID: number;
    ObjekatNaziv: string;
    GenericName: string;
    Istekao: boolean;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Checked = input.Checked;
        // this.Povezan = input.Povezan;
        this.MasterDokumID = input.MasterDokumID;
        this.Broj = input.Broj;
        this.Datum = input.Datum;
        this.Ukupno = input.Ukupno;
        this.VezaDokID = input.VezaDokID;
        this.ObjekatID = input.ObjekatID;
        this.ObjekatNaziv = input.ObjekatNaziv;
        this.GenericName = input.GenericName;
        this.Istekao = input.Istekao;
        return this;
    }

    Serialize(input: SpisakDokumenata){
        return input;
    }

    GetInstance(){
        return this;
    }
}